import axios from "axios";
import { tokenStorage } from "@/lib/tokenStorage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = tokenStorage.get("uc_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Global 402 handler — every API call goes through this. If backend paywall
// returns 402 (subscription_required) we redirect to /pricing immediately.
// Ayrıca genel sunucu/ağ hataları için TR profesyonel toast mesajları.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402) {
      const path = window.location.pathname;
      const allowed = ["/pricing", "/subscription", "/billing/success", "/billing/cancel"];
      if (!allowed.includes(path)) {
        window.location.replace("/pricing");
      }
      return Promise.reject(err);
    }
    // Bileşen bazlı hatalar (401/403/404/409/422) sayfa toast'larına bırakılır.
    // Sadece kullanıcının hiçbir şey yapamayacağı altyapı hatalarında global uyar.
    const status = err?.response?.status;
    const isNetwork = !err?.response;
    let msg = null;
    if (isNetwork) msg = "İnternet bağlantınız kesildi. Lütfen bağlantınızı kontrol edip tekrar deneyin.";
    else if (status === 500) msg = "Sunucumuzda anlık bir sorun oluştu. Lütfen birkaç saniye sonra tekrar deneyin.";
    else if (status === 502 || status === 503 || status === 504) msg = "Sistem şu an bakımda olabilir. Lütfen kısa bir süre sonra tekrar deneyin.";
    else if (status === 429) msg = "Çok hızlı işlem yaptınız. Lütfen birkaç saniye bekleyip tekrar deneyin.";
    if (msg && typeof window !== "undefined") {
      // Sonner'ı lazy import ederek dairesel bağımlılığı önle
      import("sonner").then(({ toast }) => toast.error(msg, { id: `api-${status || "net"}` })).catch(() => {});
    }
    return Promise.reject(err);
  },
);

export const WS_URL = () => {
  const httpUrl = BACKEND_URL || "";
  const wsProto = httpUrl.startsWith("https") ? "wss" : "ws";
  const host = httpUrl.replace(/^https?:\/\//, "");
  return `${wsProto}://${host}/api/ws/rates`;
};
